import React from 'react';
import Calendar from 'lucide-react/dist/esm/icons/calendar.js';
import { useTranslations } from '../../../contexts/TranslationContext';

export default function DrawsHero() {
  const { t } = useTranslations();

  return (
    <div className="text-center mb-12 animate-fade-in-up">
      <div className="flex items-center justify-center gap-3 mb-4">
        <div className="bg-gradient-to-br from-blue-500 to-cyan-500 p-3 rounded-2xl shadow-lg">
          <Calendar className="w-8 h-8 text-white" />
        </div>
        <h1 className="text-3xl md:text-5xl font-bold text-gray-900 dark:text-white">
          {t('draws.pageTitle')}
        </h1>
      </div>
      <p className="text-lg md:text-xl text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
        {t('draws.pageSubtitle')}
      </p>
    </div>
  );
}
